import { ArrowUpRight } from "lucide-react";

const REFERRAL_URL = "https://app.emergent.sh/register?ref=fran210928";

export default function BuiltWithEmergent() {
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 mt-24" data-testid="built-with-emergent">
      <div className="grid md:grid-cols-12 bg-white border border-[#e2dcd4] overflow-hidden">
        <div className="md:col-span-7 aspect-[3/2] md:aspect-auto">
          <img src="/built-with-emergent.jpg" alt="A 70-year-old Kiwi naturist building his website on a laptop, on a sunny deck above a bush-lined bay"
            className="w-full h-full object-cover" loading="lazy" data-testid="built-with-emergent-image" />
        </div>
        <div className="md:col-span-5 p-8 sm:p-12 flex flex-col justify-center">
          <p className="eyebrow">How this site was made</p>
          <h2 className="mt-4 text-3xl sm:text-4xl leading-tight tracking-tight text-[#1f402b]">
            Built by a 70-year-old Kiwi, with a little help
          </h2>
          <div className="mt-6 space-y-4 text-[#3c4a41] leading-relaxed">
            <p>I'm 70, and I built this whole website myself using Emergent, an AI website builder. You describe what you want in plain English, and it does the technical side.</p>
            <p>I didn't need to learn any code. I just told it what I wanted, one step at a time.</p>
            <p>If you're a naturist, a club or a small group wanting your own homepage or website, give it a go. If you use my link below, you'll get some bonus credits to start with.</p>
          </div>
          <a href={REFERRAL_URL} target="_blank" rel="noopener noreferrer" data-testid="built-with-emergent-link"
            className="mt-8 self-start inline-flex items-center gap-2 bg-[#c5903b] text-white px-7 py-3.5 text-sm tracking-wide hover:bg-[#a97a2f] transition-colors duration-200">
            Build your site with Emergent <ArrowUpRight size={15} />
          </a>
        </div>
      </div>
    </section>
  );
}
